// import { Add } from "@mui/icons-material";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
// import TodayOutlinedIcon from "@mui/icons-material/TodayOutlined";
// import { Box, Menu, MenuItem, Typography } from "@mui/material";
// import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
// import Flex from "../../../../../components/Flex";
// import Text from "../../../../../components/Text";
// import { NAVBAR } from "../../../../../utils/utils";
import StyledButtonV2 from "../../../../../components/app/StyledButtonV2";

interface CreateClaimPopUpProps {
  onClick: (v: "claim" | "copy") => void;
}

const CreateClaimPopUp = ({ onClick }: CreateClaimPopUpProps) => (
  <StyledButtonV2 label="Create New Claim" onClick={() => onClick("claim")} />
  // <PopupState variant="popover" popupId="create-navbar-button-menu">
  //   {(menuList) => (
  //     <>
  //       <Box
  //         borderRadius={1}
  //         bgcolor={"white"}
  //         border={"1px solid"}
  //         borderColor={"primary.main"}
  //         pl={"5.5px"}
  //         {...bindTrigger(menuList)}
  //         sx={{ cursor: "pointer" }}
  //         height={"26px"}
  //       >
  //         <Flex alignItems={"center"} gap={0.8} height={"26px"} pr={0}>
  //           <Add style={{ fontSize: "18px" }} color="primary" />
  //           <Text
  //             fontSize={NAVBAR.MENU_ITEM_FONT_SIZE}
  //             variant="button"
  //             c={"primary.main"}
  //             mr={0}
  //             sx={{ lineHeight: "0px!important" }}
  //           >
  //             Create Claim
  //           </Text>
  //           {bindMenu(menuList).open ? (
  //             <ExpandLessIcon sx={{ fontSize: "18px" }} color="primary" />
  //           ) : (
  //             <ExpandMoreIcon sx={{ fontSize: "18px" }} color="primary" />
  //           )}
  //         </Flex>
  //       </Box>
  //       <Menu {...bindMenu(menuList)}>
  //         <MenuItem
  //           onClick={() => {
  //             menuList.close();
  //             onClick("claim");
  //           }}
  //         >
  //           <Flex gap={"10px"} alignItems={"center"} justifyContent={"center"}>
  //             <PersonAddOutlinedIcon
  //               sx={{ fontSize: NAVBAR.MENU_ITEM_FONT_SIZE }}
  //             />
  //             <Typography fontSize={NAVBAR.MENU_ITEM_FONT_SIZE}>
  //               Create New Claim
  //             </Typography>
  //           </Flex>
  //         </MenuItem>
  //         <MenuItem
  //           onClick={() => {
  //             onClick("copy");
  //             menuList.close();
  //           }}
  //         >
  //           <Flex gap={"10px"} alignItems={"center"} justifyContent={"center"}>
  //             <TodayOutlinedIcon
  //               sx={{ fontSize: NAVBAR.MENU_ITEM_FONT_SIZE }}
  //             />
  //             <Typography fontSize={NAVBAR.MENU_ITEM_FONT_SIZE}>
  //               Copy From Existing Claim
  //             </Typography>
  //           </Flex>
  //         </MenuItem>
  //       </Menu>
  //     </>
  //   )}
  // </PopupState>
);

export default CreateClaimPopUp;
